import React, { Component } from "react";
import { convertDateFormat } from "../../utils/helperFunctions";
import { MDBBtn, MDBDataTable } from "mdbreact";
import { Row, Col } from "reactstrap";
import Pagination from "../Common/Pagination";
import users from "../../stores/reducers/users";
import { translate } from "react-i18next";

class AuditTrailTable extends Component {
  state = {
    loadTable: false,
    logs: [],
    pagination: {},
    role: localStorage.getItem("role"),
  };

  superAdminColumn = [
    {
      label: this.props.t("dashboard.account"),
      field: "account",
      width: 80,
    },
    {
      label: this.props.t("dashboard.action"),
      field: "action",
      sort: "asc",
      width: 100,
    },
    {
      label: this.props.t("dashboard.event"),
      field: "event",
      sort: "asc",
      width: 100,
    },
    {
      label: this.props.t("dashboard.message"),
      field: "information",
      sort: "asc",
      width: 200,
    },
    {
      label: this.props.t("dashboard.result"),
      field: "result",
      sort: "asc",
      width: 100,
    },
    {
      label: this.props.t("dashboard.time"),
      field: "time",
      sort: "desc",
      width: 200,
    },
    {
      label: this.props.t("dashboard.user"),
      field: "user",
      sort: "asc",
      width: 200,
    },
  ];

  componentDidMount() {
    const { data } = this.props;
    if (data && data.length) {
      this.showTable(true);
    } else {
      this.showTable(false);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.data !== this.props.data &&
      this.props.data &&
      this.props.data.length
    ) {
      this.showTable(true);
    }
  }

  showTable = (loadTable) => {
    if (loadTable) {
      const { data, pagination, updateFirmware } = this.props;

      const rows = data.map((item, index) => {
        let gatewayRow = { ...item };
        gatewayRow.account = gatewayRow.account || "N/A";
        gatewayRow.action = gatewayRow.action || "N/A";

        gatewayRow.information = gatewayRow.information || "N/A";
        gatewayRow.user = gatewayRow.user || "N/A";
        return gatewayRow;
      });
      this.setState({
        loadTable,
        logs: {
          columns: this.superAdminColumn,
          rows: rows,
        },
        pagination,
      });
    } else {
      this.setState({ loadTable });
    }
  };

  render() {
    const { loadTable, logs } = this.state;
    return (
      <React.Fragment>
        {loadTable ? (
          <>
            <MDBDataTable
              className="hideLastColSort recentAlarmTable border-0"
              bordered
              data={logs}
              paging={false}
              scrollX
              displayEntries={true}
              searching={false}
            />
          </>
        ) : null}
      </React.Fragment>
    );
  }
}

export default translate("translations")(AuditTrailTable);
